import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

import { useDispatch, useSelector } from "react-redux";

import '../../../components/_modals/modalStyle.css'
import { useState } from 'react';

import { selectTranslations } from '../../../services/i18n/i18nSlice';
import { setLoading } from '../../../services/global/globalSlice';
import { fetchAcceptUserExam, fetchAddUserExamNote, fetchRejectUserExam } from '../ExamApi';
import { toast } from 'react-toastify';

export default function UserExamActionModal ({props, user_exam_id}) {

    const {show, onConfirm, onClose, type='note'} = props
    const t = useSelector(selectTranslations)
    const dispatch = useDispatch()

    const [actionData, setActionData] = useState({
        message: ''
    })

    const handleDataChange = (e) => {
        const target = e.target
        const name = target.name
        const value = target.type === "checkbox" ? target.checked : target.value
        setActionData({
            ...actionData,
            [name]: value
        })
    }

    const renderTitle = () => {
        if(type ===  'note')
            return t.user_exam.modal.add_note
        else if(type ===  'approve')
            return t.user_exam.modal.accept
        else if(type ===  'reject')
            return t.user_exam.modal.reject
    }
    const renderText = () => {
        if(type ===  'note')
            return t.user_exam.modal.add_note_text
        else if(type ===  'approve')
            return t.user_exam.modal.accept_text
        else if(type ===  'reject')
            return t.user_exam.modal.reject_text
    }

    const handleAddNote = async () => {
        if(actionData?.message){
            try {
                // Sostituisci con il tuo endpoint API
                dispatch(setLoading(true))
                const response = await fetchAddUserExamNote(user_exam_id,actionData?.message)
                if(response.success){
                    toast.success("Nota aggiunta")
                    onConfirm(true)
                }
            } catch (error) {
                toast.error(`Errore durante il recupero dei dati ${error}`)
                return null;
            }
            dispatch(setLoading(false))
        }
    }

    const handleApprove = async () => {
        try {
            // Sostituisci con il tuo endpoint API
            dispatch(setLoading(true))
            const response = await fetchAcceptUserExam(user_exam_id,actionData?.message)
            if(response.success){
                toast.success("Prova Approvata")
                onConfirm(true)
            }
        } catch (error) {
            toast.error(`Errore durante il recupero dei dati ${error}`)
            return null;
        }
        dispatch(setLoading(false))
    }

    const handleReject = async () => {
        try {
            // Sostituisci con il tuo endpoint API
            dispatch(setLoading(true))
            const response = await fetchRejectUserExam(user_exam_id,actionData?.message)
            if(response.success){
                toast.success("Prova Rifiutata")
                onConfirm(true)
            }
        } catch (error) {
            toast.error(`Errore durante il recupero dei dati ${error}`)
            return null;
        }
        dispatch(setLoading(false))
    }

    return (
        <Modal
            show={show}
            onHide={onClose}
            keyboard={false}
            centered
        >
            <Modal.Body>
                <h2 className="text-center">{renderTitle()}</h2>
                <p className="text-center mb-4">{renderText()}</p>
                <Form.Group controlId="description" className='mt-2'>
                    <Form.Label>Messaggio</Form.Label>
                    <Form.Control type="text" as="textarea" value={actionData?.message || ''} name="message" placeholder={"Inserisci il tuo messaggio"} onChange={handleDataChange} />
                </Form.Group>
                {type === "note" ? 
                    <button className="mt-2 mx-auto" onClick={handleAddNote} >{t.user_exam.modal.add_note}</button>
                    : null
                }
                {type === "approve" ? 
                    <button className="mt-2 mx-auto" onClick={handleApprove} >{t.user_exam.modal.accept}</button>
                    : null
                }
                {type === "reject" ? 
                    <button className="mt-2 mx-auto" onClick={handleReject} >{t.user_exam.modal.reject}</button>
                    : null
                }
                {onClose !== null ? 
                    <button className="mt-2 secondary mx-auto" onClick={()=>onClose(false)} >{t.modals.close}</button>
                    : null
                }
            </Modal.Body>
        </Modal>
    )
}